export const MODULE_PAYROLL_ORDER = 'payroll_order';
export const MODULE_BENEFIT_ORDER = 'benefit_order';
